import { MegaphonePromptBanner } from 'app/components/prompt-banner-card';
import type { ViewProps } from 'react-native';
import { View } from 'react-native';
import { useNavigation } from 'app/hooks/navigation';
import type { NewAddressSource } from 'app/types/address';
import { useAllAddresses } from 'app/network/address';
import { useTranslation } from 'react-i18next';
import { isNotWhiteLabel } from 'app/utils/helpers';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function useAddAddressPromptCard() {
  const { data: addresses } = useAllAddresses();
  return addresses?.length === 1 && isNotWhiteLabel();
}

export function AddAddressPromptCard({
  newAddressSource,
  ...rest
}: ViewProps & {
  newAddressSource: NewAddressSource;
}) {
  const navigation = useNavigation();
  const { t } = useTranslation('all-listings');

  const show = useAddAddressPromptCard();
  if (!show) {
    return null;
  }

  const addNewAddress = () => {
    navigation.navigate(
      'newAddressModal',
      {
        screen: 'my-neighbourhood',
        params: { newAddressSource },
      },
      { pop: true },
    );
  };

  return (
    <View {...rest}>
      <MegaphonePromptBanner
        backgroundColor={theme.colors['surface.brand.secondary-5.subtle']}
        body={t('addAddressPrompt.text')}
        buttonLabel={t('addAddressPrompt.button')}
        foregroundColor={theme.colors['text.primary']}
        onPress={addNewAddress}
        plusIconColor={theme.colors['surface.brand.secondary-5.subtle']}
        title={t('addAddressPrompt.title')}
      />
    </View>
  );
}
